<template>
  <div  class="evaluatees">
    <el-tabs type="card" value="self">
      <el-tab-pane v-if="evaluation.setting && evaluation.setting.is_self" :label="'Самооценка ' + totalSelfEvaluatorCount.evaluated_count + '/' + totalSelfEvaluatorCount.all_count" name="self">
        <el-card>
          <my-evaluators-table
            @update-total-count="totalSelfEvaluatorCount = $event"
            @refresh-evaluatee="refreshEvaluatee"
            @refresh-eval-user="refreshEvalUser"
            type="self"
            :evaluation="evaluation"
          ></my-evaluators-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane v-if="evaluation.setting && evaluation.setting.is_colleague" :label="'Коллеги ' + totalColleagueEvaluatorCount.evaluated_count + '/' + totalColleagueEvaluatorCount.all_count" name="colleague">
        <el-card>
          <my-evaluators-table
            @update-total-count="totalColleagueEvaluatorCount = $event"
            @refresh-evaluatee="refreshEvaluatee"
            @refresh-eval-user="refreshEvalUser"
            type="colleague"
            :evaluation="evaluation"
          ></my-evaluators-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane v-if="evaluation.setting && evaluation.setting.is_subordinate" :label="'Подчиненные ' + totalChiefEvaluatorCount.evaluated_count + '/' + totalChiefEvaluatorCount.all_count" name="chief">
        <el-card>
          <my-evaluators-table
            @update-total-count="totalChiefEvaluatorCount = $event"
            @refresh-evaluatee="refreshEvaluatee"
            @refresh-eval-user="refreshEvalUser"
            type="chief"
            :evaluation="evaluation"
          ></my-evaluators-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane v-if="evaluation.setting && evaluation.setting.is_chief" :label="'Руководитель ' + totalSubordinateEvaluatorCount.evaluated_count + '/' + totalSubordinateEvaluatorCount.all_count" name="subordinate">
        <el-card>
          <my-evaluators-table
            @update-total-count="totalSubordinateEvaluatorCount = $event"
            @refresh-evaluatee="refreshEvaluatee"
            @refresh-eval-user="refreshEvalUser"
            type="subordinate"
            :evaluation="evaluation"
          ></my-evaluators-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MyEvaluatorsTable from "@/modules/evaluation/components/myEvaluation/MyEvaluatorsTable.vue";
import {mapGetters} from "vuex";

export default {
  name: "my-evaluators",
  components: {MyEvaluatorsTable},
  props: {
    evaluation: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      totalSelfEvaluatorCount: {
        all_count: 0,
        evaluated_count: 0,
      },
      totalColleagueEvaluatorCount: {
        all_count: 0,
        evaluated_count: 0,
      },
      totalChiefEvaluatorCount: {
        all_count: 0,
        evaluated_count: 0,
      },
      totalSubordinateEvaluatorCount: {
        all_count: 0,
        evaluated_count: 0,
      },
    }
  },
  mounted() {
    this.loadEvaluatees();
  },
  computed:{
    ...mapGetters(['user'])
  },
  methods: {
    refreshEvaluatee() {
      this.$emit('refresh-evaluatee');
      this.loadEvaluatees();
    },
    refreshEvalUser() {
      this.$emit('refresh-eval-user');
    },
    loadEvaluatees() {
      this.$api.evaluation.evaluatorsSearch({
        evaluation_id: this.$route.params.id,
        evaluator_id: this.user.id,
      })
        .then(({data}) => {
          this.$emit("update-total-count", data.allEvaluatorsInfo);
        });
    },
  },
}
</script>

<style scoped>

</style>